var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm",class:_vm.params.data.usePolly ? 'btn-success' : 'btn-link',attrs:{"type":"button"},on:{"click":_vm.togglePolly}},[_vm._v(" "+_vm._s(_vm.params.data.usePolly ? 'Disabilita' : 'Abilita')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }